/**
 * AddBuilderForm Component
 * UI-komponent för att lägga till nytt byggföretag
 * Endast rendering + event handlers - all logik i useBuilderForm hook
 */

import React from 'react';
import { BuilderFormFields } from './BuilderFormFields';
import { useBuilderForm } from '../hooks/useBuilderForm';

function AddBuilderForm({ setBuilders, builders, users = [], onClose, onSuccess }) {
  const {
    values,
    setValues,
    previewUrl,
    errors,
    isLoading,
    errorMessage,
    handleChange,
    handleAvatarChange,
    handleRemoveAvatar,
    handleSubmit
  } = useBuilderForm({
    initialBuilder: null,
    users,
    onClose,
    onSuccess,
    setBuilders,
    builders,
    isUpdate: false
  });

  return (
    <div className="p-6">
      <h2 className="text-xl font-semibold mb-4">Lägg till byggföretag</h2>
      {errorMessage && <p className="text-red-500 mb-4">{errorMessage}</p>}
      {errors.submit && <p className="text-red-500 mb-4">{errors.submit}</p>}
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <BuilderFormFields
          values={values}
          setValues={setValues}
          errors={errors}
          previewUrl={previewUrl}
          handleChange={handleChange}
          handleAvatarChange={handleAvatarChange}
          handleRemoveAvatar={handleRemoveAvatar}
          isUpdate={false}
        />
        
        <div className="flex space-x-4 pt-4">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 bg-gray-500 text-white p-2 rounded hover:bg-gray-600 
                     transition-colors duration-200"
          >
            Avbryt
          </button>
          <button
            type="submit"
            disabled={isLoading}
            className="flex-1 bg-leadme-pink text-white p-2 rounded hover:bg-leadme-pink-dark 
                     disabled:bg-leadme-pink/50 transition-colors duration-200"
          >
            {isLoading ? 'Sparar...' : 'Spara'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddBuilderForm;

